import { render, staticRenderFns } from "./EstadisticaColegiados.vue?vue&type=template&id=0e8b1181"
import script from "./EstadisticaColegiados.vue?vue&type=script&lang=js"
export * from "./EstadisticaColegiados.vue?vue&type=script&lang=js"
import style0 from "./EstadisticaColegiados.vue?vue&type=style&index=0&id=0e8b1181&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports